import React, { CSSProperties, PropsWithChildren } from 'react';

import { Message } from '@utils/message';
import { ErrorLike } from '@utils/yup';

import { Text } from '@atoms';

export type FormInputLabelsProps = {
  label?: Message;
  boldLabel?: boolean;
  error?: ErrorLike;
  touched?: boolean;
};

type Props = PropsWithChildren<
  {
    className?: string;
    style?: CSSProperties;
  } & FormInputLabelsProps
>;

export const FormInputLabels = ({
  children,
  className,
  style,
  label,
  boldLabel,
  error,
  touched,
}: Props) => {
  return (
    <div className={className} style={style}>
      {/* label */}
      {label && (
        <Text
          type="reduced"
          textAlign="left"
          color={boldLabel ? 'big_stone' : 'biscay'}
          fontWeight={boldLabel ? 600 : 400}
          message={label}
        />
      )}

      {/* input */}
      {children}

      {/* error message */}
      {touched && error && (
        <Text
          type="small"
          color="monza"
          margin={[9, 0, 0]}
          message={{ id: error.message as any }}
        />
      )}
    </div>
  );
};
